import React from "react";
import GenericTable from "../../GenericTable";

/* ---------------------------- Devices Table ---------------------------- */
export const Devices = () => {
  const visibleColumns = [
    { key: "device_address", label: "Address" },
    { key: "device_label", label: "Label" },
    { key: "device_vendor", label: "Vendor" },
    { key: "device_template", label: "Template" },
    { key: "profiles", label: "Profiles" },
    { key: "device_enabled", label: "Enabled" },
    { key: "device_status", label: "Status" },
    { key: "device_description", label: "Description" },
  ];

  const booleanColumns = ["device_enabled"];

  return (
    <GenericTable
      tableName="v_devices"
      title="Devices"
      singularTitle="Device"
      parentName="HUCS"
      addRoute="/admin/hucs/add/devices"
      editBaseRoute={(device) => `/admin/hucs/edit/device/${device.device_uuid}`}
      rowKey="device_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------------- Device Vendors Table ---------------------------- */
export const DeviceVendors = () => {
  const visibleColumns = [
    { key: "name", label: "Name" },
    { key: "enabled", label: "Enabled" },
    { key: "description", label: "Description" },
  ];

  const booleanColumns = ["enabled"];

  return (
    <GenericTable
      tableName="v_device_vendors"
      title="Device Vendors"
      singularTitle="Device Vendor"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_device_vendors"
      editBaseRoute={(vendor) =>
        `/admin/hucs/edit/device-vendor/${vendor.vendor_uuid}`
      }
      rowKey="vendor_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------------- Gateways Table ---------------------------- */
export const Gateways = () => {
  const visibleColumns = [
    { key: "gateway", label: "Gateway" },
    { key: "proxy", label: "Proxy" },
    { key: "context", label: "Context" },
    { key: "register", label: "Register" },
    { key: "status", label: "Status" },
    { key: "action", label: "Action" },
    { key: "state", label: "State" },
    { key: "hostname", label: "Hostname" },
    { key: "enabled", label: "Enabled" },
    { key: "description", label: "Description" },
  ];

  const booleanColumns = ["register", "enabled"];

  return (
    <GenericTable
      tableName="v_gateways"
      title="Gateways"
      parentName="HUCS"
      singularTitle="Gateway"
      addRoute="/admin/hucs/add/v_gateways"
      editBaseRoute="/admin/hucs/edit"
      rowKey="gateway_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------------- Extensions Table ---------------------------- */
export const Extensions = () => {
  const visibleColumns = [
    { key: "extension", label: "Extension" },
    { key: "effective_caller_id_name", label: "Effective CID Name" },
    { key: "outbound_caller_id_name", label: "Outbound Name" },
    { key: "outbound_caller_id_number", label: "Outbound Number" },
    { key: "call_group", label: "Call Group" },
    { key: "address", label: "Address" },
    { key: "call_screen_enabled", label: "Template" },
    { key: "user_context", label: "Context" },
    { key: "enabled", label: "Enabled" },
    { key: "description", label: "Description" },
  ];

  const booleanColumns = ["call_screen_enabled", "enabled"];

  return (
    <GenericTable
      tableName="v_extensions"
      title="Extensions"
      parentName="HUCS"
      singularTitle="Extension"
      addRoute="/admin/hucs/add/extension"
      editBaseRoute={(extension) => `/admin/hucs/edit/extension/${extension.extension_uuid}`}
      rowKey="extension_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------- Extension Settings Table ---------------------- */
export const ExtensionSettings = () => {
  const visibleColumns = [
    { key: "extension_setting_type", label: "Type" },
    { key: "extension_setting_name", label: "Name" },
    { key: "extension_setting_value", label: "Value" },
    { key: "extension_setting_enabled", label: "Enabled" },
    { key: "extension_setting_description", label: "Description" },
  ];

  const booleanColumns = ["extension_setting_enabled"];

  return (
    <GenericTable
      tableName="v_extension_settings"
      title="Extension Settings"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_extension_settings"
      editBaseRoute="/admin/hucs/edit"
      rowKey="extension_setting_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------------- Users Table ---------------------------- */
export const Users = () => {
  const visibleColumns = [
    { key: "username", label: "Username" },
    { key: "groups", label: "Groups" },
    { key: "organization", label: "Organization" },
    { key: "first_name", label: "Name" },
    { key: "note", label: "Note" },
    { key: "enabled", label: "Enabled" },
  ];

  const booleanColumns = ["enabled"];

  return (
    <GenericTable
      tableName="v_users"
      title="Users"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_users"
      editBaseRoute="/admin/hucs/edit"
      rowKey="user_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

export default { Devices, DeviceVendors, Gateways, Extensions, ExtensionSettings, Users };
